import { Component, ChangeDetectionStrategy, ContentChild, ChangeDetectorRef } from '@angular/core';
import { AmdInputDirective } from '../input/input.directive';
export class AmdInputContainerComponent {
    /**
     * @param {?} changeDetectorRef
     */
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this._isFocussed = false;
    }
    /**
     * @param {?} isFocussed
     * @return {?}
     */
    set isFocussed(isFocussed) {
        this._isFocussed = isFocussed;
        this.changeDetectorRef.markForCheck();
    }
    /**
     * @return {?}
     */
    get isFocussed() {
        return this._isFocussed;
    }
    /**
     * @return {?}
     */
    focus() {
        this.isFocussed = true;
        this.input.setFocus(true);
    }
    /**
     * @return {?}
     */
    blur() {
        this.isFocussed = false;
        this.input.setFocus(false);
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        if (!this.input) {
            throw new Error('amdInput is required as a child of amdInputContainer');
        }
        this.input.isFocussedChange.subscribe((isFocussed) => this.isFocussed = isFocussed);
    }
}
AmdInputContainerComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-input-container',
                template: "<span class=\"amd-input-container\" [class.amd-input-container--focussed]=\"isFocussed\"> <ng-content></ng-content> </span>",
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
/**
 * @nocollapse
 */
AmdInputContainerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef, },
];
AmdInputContainerComponent.propDecorators = {
    'input': [{ type: ContentChild, args: [AmdInputDirective,] },],
};
function AmdInputContainerComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdInputContainerComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdInputContainerComponent.ctorParameters;
    /** @type {?} */
    AmdInputContainerComponent.propDecorators;
    /** @type {?} */
    AmdInputContainerComponent.prototype._isFocussed;
    /** @type {?} */
    AmdInputContainerComponent.prototype.input;
    /** @type {?} */
    AmdInputContainerComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=input-container.component.js.map
//# sourceMappingURL=input-container.component.js.map
